<div class="row">

    <div class="products">

        <ng-container *ngFor="let category of categories">
            <ng-container *ngIf="category.id != 35">

                <div class="category-title">
                    {{ category.title }}
                </div>

                <div class="col-12">
                    <div class="row portfolio-grid" *ngIf="productsByCategory[category.id]">
                        <ng-container *ngFor="let product of productsByCategory[category.id]; let i = index">
                            <div *ngIf="product.images.length > 0"
                                 (click)="addProductToPreferred(product)"
                                 class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 product-col">
                                <figure class="recipe-figure">
                                    <div
                                            (click)="addProductToPreferred(product)"
                                            class="card-img-top animated fadeIn recipe-influencer-image"
                                            [lazyLoad]="constants.imagesUrl() + '/images/300x150/' + product.images[0].type + '/' + product.images[0].name + '/'">

                                        <div class="recipe-check"
                                             [ngClass]="isProductPreferred(product) ? 'checked' : ''"
                                             (click)="addProductToPreferred(product)">
                                            <i class="fa fa-check"></i>
                                        </div>
                                    </div>

                                    <figcaption>
                                        <h4
                                                class="recipe-title-influencer">{{ product.title }}</h4>
                                    </figcaption>
                                </figure>
                            </div>

                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <div class="products-btn-wrapper">
            <button (click)="updateUserPreferredProducts()"
                    class="btn btn-block btn-success">
                {{ 'save' | localise }} ( {{ selectedPreferredProducts.length }} )
            </button>
        </div>
    </div>
</div>
